import { render, staticRenderFns } from "./ReviewRentChange.vue?vue&type=template&id=05991f3c&"
import script from "./ReviewRentChange.vue?vue&type=script&lang=js&"
export * from "./ReviewRentChange.vue?vue&type=script&lang=js&"
import style0 from "./ReviewRentChange.vue?vue&type=style&index=0&id=05991f3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports